import devEndpoints from "./dev.endpoints"
export default {
    ...devEndpoints
}